import CacheRoute, { CacheSwitch } from 'react-router-cache-route';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';

import Loadable from "@/Loadable";
import NavUtils from "@utils/NavUtils";
import Path from './path';
import React from 'react';
import { createBrowserHistory } from 'history';

const Login = Loadable(() => import('@page/login/LoginPage'));
const Reg = Loadable(() => import('@page/login/RegPage'));
const Forget = Loadable(() => import('@page/login/ForgetPage'));
const Caster = Loadable(() => import('@page/caster/Caster'));
const HEALTHY = Loadable(() => import('@page/dataStatistics/healthyData/HealthyDataPage'));
const NotFound = Loadable(() => import('@page/exception/NotFound'));
const Layout = Loadable(() => import('../layout/index'));

export default function appRoutes() {
  const browserHistory = createBrowserHistory();
  const routingStore = new RouterStore();
  const history = syncHistoryWithStore(browserHistory, routingStore);
  NavUtils.setHistory(history);

  return (
    <Router history={history}>
      <Switch>
        <Route exact path={Path.LOGIN} name="登录" component={Login} />
        <Route exact path={Path.REG} name="注册" component={Reg} />
        <Route exact path={Path.FORGET} name="忘记密码" component={Forget} />
        <Route exact path={Path.CASTER} name="导播台" component={Caster} />
        <Route exact path={Path.HEALTHY} name="健康大屏" component={HEALTHY} />
        <Route path={Path.ROOT} name="根布局" component={Layout} />
      </Switch>
    </Router>
  );
}

export function menuRoutes(menuMap = []) {
  return <CacheSwitch>
    {
      menuMap.map((route, key) => {
        const { path, component: Comp, name } = route;
        return <CacheRoute exact path={path} name={name} cacheKey={path} component={Comp} key={key} />;
      })
    }
    <Redirect exact from={Path.ROOT} to={Path.HOME} name="默认首页跳转" />
    <Route name="404" component={NotFound} />
  </CacheSwitch>;
}

export const otherMenu = [
  {
    component: "ProfilePage",
    icon: "",
    links: false,
    visible: false,
    name: "个人中心",
    routePath: Path.PROFILE.slice(1),
    type: 2,
  },
  {
    component: "HomePage",
    icon: "",
    links: false,
    visible: false,
    name: "首页",
    routePath: Path.HOME.slice(1),
    type: 2,
  }
];
